// assets/upsell-popdown.js
(function(){
  console.log('🔌 Upsell add/remove + popdown script loaded');

  function init() {
    const clips = document.querySelectorAll('.cross-product-clip');
    if (clips.length === 0) {
      return setTimeout(init, 150);
    }

    clips.forEach(clip => {
      const box    = clip.querySelector('input[name="add_to_order"]');
      const select = clip.querySelector('select[name="variant_id"]');
      if (!box || !select) return;

      // reset checkbox if user switches variant
      select.addEventListener('change', () => {
        box.checked = false;
        console.log('🔄 Variant changed – checkbox reset');
      });

      // on checkbox toggle
      box.addEventListener('change', function(){
        const variantId = select.value;

        if (this.checked) {
          console.log('↪️ Adding variant', variantId, 'to cart…');
          // 1) AJAX add
          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
          })
          .then(r => r.json())
          .then(item => {
            console.log('✅ Added to cart:', item);
            // 2) refresh drawer data
            return fetch('/cart.js').then(r => r.json());
          })
          .then(cart => {
            // 3a) tell drawer to re-render
            document.dispatchEvent(new CustomEvent('theme:cart:change', {
              detail: { cart },
              bubbles: true
            }));
            // 3b) trigger your pop-down
            document.dispatchEvent(new CustomEvent('theme:cart:popdown', {
              detail: { variant: { id: parseInt(variantId, 10) } },
              bubbles: true
            }));
          })
          .catch(err => {
            console.error('❌ Add error:', err);
         //   alert(err.message || 'Could not add to cart');
            this.checked = false;
          });

        } else {
          console.log('↪️ Removing variant', variantId, 'from cart…');
          // 1) AJAX remove
          fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ updates: { [variantId]: 0 } })
          })
          .then(r => r.json())
          .then(cart => {
            console.log('🗑 Removed, new cart:', cart);
            // refresh drawer to reflect removal
            document.dispatchEvent(new CustomEvent('theme:cart:change', {
              detail: { cart },
              bubbles: true
            }));
          })
          .catch(err => {
            console.error('❌ Remove error:', err);
           // alert(err.message || 'Could not remove from cart');
            this.checked = true;
          });
        }
      });
    });

    console.log('✅ Upsell clips wired');
  }

  document.addEventListener('DOMContentLoaded', init);
})();
